import { useContext } from 'react';
import { Row, Form, Col } from 'react-bootstrap';
import { CategoryContext } from '../../../../context/category';

export function Printers() {
  const { xdPrinters, setXdPrinters, xdFollowItem, setXdFollowItem } =
    useContext(CategoryContext);

  // Garantir que xdPrinters tenha um valor padrão se for undefined ou null
  const printersArray = xdPrinters || '0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0';

  return (
    <div className="px-4 mt-3">
      {/* Checkbox "Segue Produto Principal" */}
      <Row className="mb-2 px-2">
        <Col id="idSwitch" md="4" className="mb-2">
          <Form.Switch
            label="Segue Produto Principal"
            onChange={(e) => setXdFollowItem(e.target.checked)}
            checked={xdFollowItem || false}
          />
        </Col>
      </Row>

      <hr className="my-3" />

      {/* Locais de Impressão */}
      <Row className="mb-2 px-2">
        {printersArray.split(',').map((item: any, index: any) => {
          return (
            <Col id="idSwitch" md="4" className="mb-2" key={index}>
              <Form.Switch
                label={`Local de impressão ${index + 1}`}
                onChange={(e: any) => {
                  const newArray = [...printersArray.split(',')];
                  newArray[index] = e.target.checked ? '1' : '0';
                  setXdPrinters(newArray.join(','));
                }}
                checked={item === '0' ? false : true}
                disabled={xdFollowItem}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
}